module.exports = __webpack_public_path__ + "images/TRUCK.53756c4edba39b12645cb86a4051d4c8.png";